<template>
  <template v-if="shouldShow">
    <slot />
  </template>
</template>
  
<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useServices } from '../../services';

interface IComponentProps {
  feature: string
}

const props: IComponentProps = defineProps<IComponentProps>()

const { Features } = useServices();

let shouldShow = ref(false);

onMounted(() => {
  shouldShow.value = Features.IsFeatureActive(props.feature)
});

</script>
  